import MarketIndexSummaryCards from './MarketIndexSummaryCards';
import MarketLineChartView from './MarketLineChartView';
import useMarketData from './hooks/useMarketData';

function CommoditiesView() {
  const { dates, series, loading, error } = useMarketData('commodities');

  return (
    <>
      <div className="row market-summary-row mb-4">
        <MarketIndexSummaryCards series={series} loading={loading} />
      </div>
      <div className="row mb-4">
        <MarketLineChartView
          chartId="commodities"
          title="Commodities"
          series={series}
          dates={dates}
          loading={loading}
          error={error}
        />
      </div>
    </>
  );
}

export default CommoditiesView;
